export default {
	isPqyUser: false,
	isNew: '',
	resultList: [],
	fileNames: [],

	useYnList: [],
	lgrpList: [],
	sgrpList: [],
	sgrpAllList: [],
	tymaList: [],
	ipnWayList: [],
	utmList: [],
	icrtList: [],
	searchParams: SEARCH_PARAMS(),
	pagingInfo: PAGING_INFO(),
	selectedRow: SELECTED_ROW(),
	oldSelectedRow: SELECTED_ROW()
};

function SEARCH_PARAMS() {
	return {
		useYn: 'Y',
		lgrpCd: [],
		sgrpCd: []
	};
}

function PAGING_INFO() {
	return {
		currentPage: 1,
		endPage: 1,
		pageUnit: 30,
		startPage: 1,
		totalSize: 1
	};
}

function SELECTED_ROW() {
	return {
		rnum: '',
		tymaCd: '',
		lgrpCd: '',
		ckuLgrpCd: '',
		sgrpCd: '',
		ckuSgrpCd: '',
		ipnWayCd: '',
		icrtCd: '',
		useYn: 'Y',
		utmCd: '',
		tymaNm: '',
		lgrpNm: '',
		sgrpNm: '',
		ipnWayNm: '',
		icrtNm: '',
		useYnNm: '사용',
		utmNm: '',
		ipnPrvsSbc: '',
		obveScpVal: '',
		minVal: '',
		maxVal: '',
		fwdImgFile: {},
		fwdImgFileDb: {},
		fwdImgFileId: '',
		creDataScnCd: ''
	};
}
export { SEARCH_PARAMS, PAGING_INFO, SELECTED_ROW };
